import React from "react";
import { Form, Button, Modal, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import { determineEffluentUnits } from "../../../../utils/dataAndFormulas/effluentForms";
import { effluentCodes } from "../../../../utils/dataAndFormulas/effluentForms";
import { useLanguage } from "../../../../contexts";
import "./UnitsForm.scss";

export function UnitsForm(props) {
  const { show, onClose, onSave, currentUnits, registeredFields } = props;
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  // Lista de todos los campos de efluentes por defecto
  const allEffluentFields = [
    { key: "domestic_effluents", label: t("domestic_effluents") },
    { key: "industrial_effluents", label: t("industrial_effluents") },
    { key: "combined_effluents", label: t("combined_effluents") },
    { key: "sludge_and_mud", label: t("sludge_and_mud") },
    { key: "recycled_effluents", label: t("recycled_effluents") },
    { key: "treatment_cost_domestic_effluents", label: t("treatment_cost_domestic_effluents") },
    { key: "industrial_effluent_treatment_cost", label: t("industrial_effluent_treatment_cost") },
    { key: "combined_treatment_cost", label: t("combined_treatment_cost") },
    { key: "sludge_treatment_cost", label: t("sludge_treatment_cost") },
  ];

  // Si hay registeredFields con datos, usar solo los campos activos
  // Si no hay registeredFields o está vacío, usar todos los campos por defecto
  const effluentFields =
    registeredFields && registeredFields.length > 0
      ? registeredFields
          .filter((field) => field.active !== false) // Solo campos activos
          .map((field) => ({
            key: field.name,
            label: t(field.name),
            code: field.code,
          }))
      : allEffluentFields;

  const formik = useFormik({
    initialValues: effluentFields.reduce((acc, field) => {
      acc[field.key] = currentUnits?.[field.key] || "";
      return acc;
    }, {}),
    enableReinitialize: true,
    onSubmit: (values) => {
      onSave(values);
      onClose();
    },
  });

  return (
    <Modal open={show} onClose={onClose} size="large" className="units-form-modal">
      <Modal.Content scrolling>
        <Form onSubmit={formik.handleSubmit}>
          <div className="units-form-modal__title">{t("configure_units")}</div>
          <div className="units-grid">
            {effluentFields.map((field) => (
              <div key={field.key} className="unit-row">
                <span className="unit-label">{field.label}</span>
                <Dropdown
                  placeholder={t("select_unit")}
                  fluid
                  selection
                  search
                  clearable
                  options={determineEffluentUnits(field.key).map((unit) => ({
                    key: unit.key,
                    text: t(unit.name),
                    value: unit.value,
                  }))}
                  value={formik.values[field.key]}
                  onChange={(_, data) => formik.setFieldValue(field.key, data.value)}
                />
              </div>
            ))}
          </div>
        </Form>
      </Modal.Content>
      <Modal.Actions style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
                <Button  primary onClick={formik.handleSubmit}>
            {t("save")}
          </Button>
          <Button onClick={onClose} className="units-btn-cancel">{t("cancel")}</Button>
    
      </Modal.Actions>
    </Modal>
  );
}
